// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconSocialLinkedin = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M73,0 C79.0751322,0 84,4.92486775 84,11 C84,17.0751322 79.0751322,22 73,22 C66.9248678,22 62,17.0751322 62,11 C62,4.92486775 66.9248678,0 73,0 Z M69.6860715,8.99027477 L67.1982141,8.99027477 L67.1982141,17.0018823 L69.6860715,17.0018823 L69.6860715,8.99027477 Z M76.0192856,8.7893819 C74.8088391,8.7893819 73.9974996,9.45366813 73.6653569,10.0831324 L73.6305354,10.0831324 L73.6305354,8.99027477 L71.2444638,8.99027477 L71.2444638,17.0018823 L73.7296424,17.0018823 L73.7296424,13.0349178 C73.7296424,11.9902749 73.9278565,10.9804535 75.221339,10.9804535 C76.496071,10.9804535 76.5148214,12.1724174 76.5148214,13.101882 L76.5148214,17.0018823 L79,17.0018823 L79,12.6009897 C79,10.4474175 78.5371429,8.7893819 76.0192856,8.7893819 Z M69.1612054,5.19518083 C68.2006696,4.64061483 67,5.33382192 67,6.44295309 C67,7.23848915 67.6452678,7.89741791 68.4408034,7.89741791 C69.2360714,7.89741791 69.8816073,7.23848915 69.8816073,6.44295309 C69.8816073,5.92820354 69.6069916,5.45255519 69.1612054,5.19518083 Z"
                transform="translate(-62)"
            />
        </svg>
    );
};

export default React.memo(IconSocialLinkedin);
